export default __webpack_public_path__ + "static/media/slide1.a39b102c.jpg";